<template>
  <div>
    <v-dialog :value="showDialog"
              @input="close"
              scrollable
              lazy
              :fullscreen="fullscreen"
              max-width="800px">
      <v-toolbar v-if="fullscreen" dark color="nx-primary--darken-2" fixed>
        <v-btn icon dark @click.native="close">
          <v-icon color="accent">close</v-icon>
        </v-btn>
        <v-toolbar-title>{{ $t('message.metadata.moreInfo') }}</v-toolbar-title>
      </v-toolbar>
      <v-card class="nx-entity-metadata-dialog">
        <v-card-text class="card-content" :class="{ fullscreen }">
          <nx-entity-metadata :id="id" :type="type"></nx-entity-metadata>
        </v-card-text>
        <v-card-actions class="card-actions" v-if="!fullscreen">
          <v-layout row justify-end>
            <v-btn v-if="hasTranscoding"
                   flat color="secondary" v-text="$t(`message.transcoding.checkState`)" @click="openTranscodingDialog"/>
            <v-btn flat color="secondary" v-text="$t('message.common.close')" @click="close"/>
          </v-layout>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <nx-entity-metadata-transcoding-state-dialog v-if="hasTranscoding"
                                                 :id="id" :type="type" v-model="transcodingDialog"/>
  </div>
</template>

<script>
import NxEntityMetadata from '@/modules/entity/metadata/EntityMetadata';
import NxEntityMetadataTranscodingStateDialog from '@/modules/entity/metadata/EntityMetadataTranscodingStateDialog';
import { transcodificableContents } from '@/modules/content/editor/config';

export default {
  name: 'nx-entity-metadata-dialog',
  components: {
    NxEntityMetadataTranscodingStateDialog,
    NxEntityMetadata,
  },
  props: {
    id: {
      type: Number,
      required: true,
    },
    type: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      showDialog: false,
      transcodingDialog: false,
    };
  },
  computed: {
    fullscreen() {
      return this.$vuetify.breakpoint.smAndDown;
    },
    hasTranscoding() {
      return transcodificableContents.includes(this.type);
    },
  },
  methods: {
    async open() {
      this.showDialog = true;
    },
    openTranscodingDialog() {
      this.transcodingDialog = true;
    },
    close() {
      this.showDialog = false;
    },
  },
};
</script>

<style lang="stylus">
.nx-entity-metadata-dialog {
  .card-content {
    margin: 0;
    padding: 0;

    &.fullscreen {
      padding-top: 56px;
    }
  }

  .card-actions {
    height: 58px;
  }
}
</style>
